import type { LucideIcon } from "lucide-react";

/**
 * O maquinário dos bônus escritos em Markdown — um por produto, três por
 * oferta, cada `##` uma tela.
 *
 * Nasceu em src/pages/cleanCakes/bonuses.ts, foi copiado para o Clean Meals
 * com uma dívida declarada ("quando um terceiro módulo precisar de bônus,
 * extrair"), e o terceiro chegou: os três do Clean Bakes (oferta do funil do
 * Clean Cakes, 25/09/2026). Os três produtos apontam para cá.
 *
 * O corte segue a versão do Clean Meals, que é a mais completa:
 *
 * 1. A ABERTURA É PRESERVADA. O que vem antes do primeiro `##` — tirando a
 *    primeira linha quando ela só repete o título — é a nota da narradora e
 *    volta em `abertura`. Quem não a mostra (o Clean Cakes) simplesmente não
 *    lê o campo; nada se perde em silêncio.
 * 2. SEM NENHUM `##`, O CORPO INTEIRO VIRA UMA TELA (o Plate Swap Chart é uma
 *    tabela só).
 */
export interface BonusScreen {
  id: string;
  title: string;
  markdown: string;
}

export interface BonusMd {
  slug: string;
  title: string;
  subtitle: string;
  icone: LucideIcon;
  /** O que vem antes do primeiro `##`, sem o título repetido. */
  abertura: string;
  screens: BonusScreen[];
}

export const slugify = (heading: string) =>
  heading
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 60);

export function recortar(raw: string, tituloDoBonus: string): { abertura: string; screens: BonusScreen[] } {
  const partes = raw.split(/^## (.+)$/m);

  // partes[0] é a abertura; depois vêm pares [título, corpo].
  const preambulo = partes[0].trim();
  const linhas = preambulo.split("\n");
  const primeira = linhas[0].replace(/^#+\s*/, "").trim();
  const abertura = (primeira.toLowerCase() === tituloDoBonus.toLowerCase()
    ? linhas.slice(1)
    : linhas
  ).join("\n").trim();

  const screens: BonusScreen[] = [];
  for (let i = 1; i < partes.length; i += 2) {
    const title = partes[i].trim();
    screens.push({ id: slugify(title), title, markdown: (partes[i + 1] ?? "").trim() });
  }

  if (screens.length === 0) {
    return {
      abertura: "",
      screens: [{ id: slugify(tituloDoBonus), title: tituloDoBonus, markdown: raw.trim() }],
    };
  }
  return { abertura, screens };
}

export function montarBonus(slug: string, title: string, subtitle: string, icone: LucideIcon, raw: string): BonusMd {
  return { slug, title, subtitle, icone, ...recortar(raw, title) };
}
